import Footer from "components/footer/FooterAuthDefault";
import { Link, useSearchParams } from "react-router-dom";
import phoneImg from "assets/img/home/phone.png";
import appstoreImg from "assets/img/home/appstore.png";
import playstoreImg from "assets/img/home/playstore.png";
import SignIn from "views/auth/SignIn";
import { HiChevronLeft } from "react-icons/hi";
import CustomHeader from "views/home/CustomHeader";
import { useDispatch } from "react-redux";
import { useEffect, useRef } from "react";
import { logoutUser } from "services/users/authSlice";
import { errorToast } from "services/globalFunctions";

export default function Auth() {
  const [searchParams] = useSearchParams();
  const mount = useRef(true);

  const dispatch = useDispatch();
  useEffect(() => {
    if (mount.current) {
      mount.current = false;
      if (searchParams.get("isTokenExpired") === "true") {
        dispatch(logoutUser());
        errorToast("Хандах эрхийн хугацаа дууссан байна.");
      }
    }
  }, [searchParams, dispatch]);
  return (
    <div className=" w-full ">
      <div className="  absolute z-[-1] flex h-full w-full content-center justify-center bg-opacity-50">
        <div className="h-full bg-white lg:w-8/12"></div>
      </div>
      <div className="z-[1] flex h-[100vh] w-full justify-center bg-purple-900 bg-opacity-80 dark:!bg-navy-700 ">
        <div className="absolute left-0 z-[2] lg:top-10 lg:left-10">
          <Link to="/">
            <HiChevronLeft className="h-16 w-16 text-white" />
          </Link>
        </div>
        <div className="grid-cols:1 px-62 px-6 py-12 lg:grid lg:w-8/12 lg:grid-cols-2 lg:gap-10 lg:px-24">
          <CustomHeader type={2} />
          <div className="py-6 lg:py-0">
            <SignIn />
          </div>
          <div className=" justify-center lg:row-span-6 lg:w-11/12">
            <img
              src={phoneImg}
              alt="Утас"
              className="w-3/3 mb-3 hidden lg:block"
            />
            <div className="flex justify-center gap-4 lg:mt-5">
              <a target="blank" href="https://play.google.com/store/games">
                <img src={playstoreImg} alt="Утас" className="mb-3" />
              </a>
              <a target="blank" href="https://www.apple.com/app-store/">
                <img src={appstoreImg} alt="Утас" className="mb-3" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
